import { IAccordionHeader, ITableDataRow } from '../../types';
import { getFormula } from '../../utils';

interface IProps {
  headers: IAccordionHeader[] | undefined;
  holdingPeriodA: string;
  holdingPeriodB: string;
  time: string;
}

export const getLTCGTable = (props: IProps) => {
  const { headers = [] } = props;
  const datas = [];
  const rows: ITableDataRow[] = [];
  const formulaValues = getFormula('LTCG_FORMULA', {
    ...props,
  });

  const isShortTerm =
    (props.time === 'Before' && props.holdingPeriodA === 'Less') ||
    (props.time === 'After' && props.holdingPeriodB === 'More');

  const heading = isShortTerm ? 'Short' : 'Long';

  let row = [
    {
      value: heading + ' Term Capital Gain',
      className: 'bg-white',
    },
    {
      value:
        '₹' + (isShortTerm ? formulaValues.shortTerm : formulaValues.longTerm),
      className: 'bg-white',
    },
  ];
  rows.push({ data: row });

  row = [
    {
      value: 'Exemption (Max: Rs 1,25,000 for LTCG)',
      className: 'bg-white',
    },
    {
      value: '₹' + (isShortTerm ? 0 : formulaValues.exemption),
      className: 'bg-white',
    },
  ];
  rows.push({ data: row });

  row = [
    {
      value: `Taxable ${heading} Term Capital Gain`,
      className: 'bg-white',
    },
    {
      value:
        '₹' +
        (isShortTerm ? formulaValues.taxableSTCG : formulaValues.taxableLTCG),
      className: 'bg-white',
    },
  ];
  rows.push({ data: row });

  row = [
    {
      value: `${heading} Term Capital Gain Tax @ ${
        isShortTerm ? '20%' : '12.5%'
      }`,
      className: 'bg-white',
    },
    {
      value:
        '₹' +
        (isShortTerm ? formulaValues.shortTermTax : formulaValues.longTermTax),
      className: 'bg-white',
    },
  ];
  rows.push({ data: row });

  datas.push({
    type: 'table',
    title: '',
    data: [
      {
        headers: headers,
        rows: rows,
      },
    ],
  });

  return datas;
};
